import { State } from '@ispm-client/modules/bpmn-modeler/store/state';
import { createSelector, MemoizedSelector } from '@ngrx/store';
import { selectBpmnModelerState } from '@ispm-client/modules/bpmn-modeler/store/selectors/bpmn-modeler-state.selector';
import { PathwaysAuthoringState } from '@ispm/shared/constants/pathways-authoring-state';

/**
 * Created By Elia Rohana on 2/12/19
 */
const getModelerState = (state: State): PathwaysAuthoringState => state.modelerState;

export const selectModelerState: MemoizedSelector<object, PathwaysAuthoringState> = createSelector(selectBpmnModelerState, getModelerState);
